import axios from "axios";

export const basecampApiRequest = axios.create({
  baseURL: process.env.REACT_APP_BASECAMP_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});
